import { z } from "zod";

const productEnum = z.enum(["cgm", "sensorsOnly"], {
  required_error: "Product is required",
});
const deliveryMethodSensorsDelivered = z.enum(
  ["sentToHome", "pickupAtPharmacy"],
  { required_error: "Delivery method is required" },
);
const deliveryMethodPharmacy = z.enum(["sentToHome", "pickupAtPharmacy"], {
  required_error: "Delivery method is required",
});
const cancellationEnum = z.enum(["yes", "no"], {
  required_error: "Cancellation status is required",
});
const sensorsEnum = z.enum(["2", "6"], {
  required_error: "Please select an option",
});
const monthNumber = z.number({
  required_error: "Month must be between 1 and 12",
});
const yearNumber = z.number({ required_error: "Year must be after 1900" });
const readerOptions = z.enum(["yes", "no"], {
  required_error: "Please select an option",
});

const lastSensorsReceivedFields = z.object({
  lastSensorsReceivedMonth: monthNumber,
  lastSensorsReceivedYear: yearNumber,
  lastSensorsReceivedQty: sensorsEnum,
});

const supplierFields = z
  .object({
    lastSensorsSupplierName: z
      .string({ required_error: "Supplier name is required" })
      .nonempty({ message: "Supplier name is required" }),
  })
  .merge(lastSensorsReceivedFields);

const baseSensorsDelivered = z.object({
  product: productEnum,
  sensorsDeliveryMethod: deliveryMethodSensorsDelivered,
  cancelledWithLastSupplier: cancellationEnum,
});

export const sensorsDeliveredCgmNoSchema = baseSensorsDelivered;
export const sensorsDeliveredCgmYesSchema =
  baseSensorsDelivered.merge(supplierFields);

const sensorsOnlyFields = z.object({
  cgmReader: z.string({ required_error: "Reader is required" }),
  stillHaveReader: readerOptions,
  month: monthNumber,
  year: yearNumber,
});

export const sensorsDeliveredSensorsOnlyNoSchema =
  baseSensorsDelivered.merge(sensorsOnlyFields);
export const sensorsDeliveredSensorsOnlyYesSchema = baseSensorsDelivered
  .merge(sensorsOnlyFields)
  .merge(supplierFields);

const basePharmacy = z.object({
  product: productEnum,
  sensorsDeliveryMethod: deliveryMethodPharmacy,
});

const pharmacyCommonFields = z
  .object({
    cancelledWithLastSupplier: cancellationEnum.optional(),
  })
  .merge(lastSensorsReceivedFields);

export const pharmacyCgmSchema = basePharmacy.merge(pharmacyCommonFields);

export const pharmacySensorsOnlySchema = basePharmacy
  .merge(
    z.object({
      cgmReader: z.string({ required_error: "Reader is required" }),
      stillHaveReader: readerOptions,
      month: monthNumber,
      year: yearNumber,
    }),
  )
  .merge(pharmacyCommonFields);

export const productInformationFormSchema = z.union([
  sensorsDeliveredCgmNoSchema,
  sensorsDeliveredCgmYesSchema,
  sensorsDeliveredSensorsOnlyNoSchema,
  sensorsDeliveredSensorsOnlyYesSchema,
  pharmacyCgmSchema,
  pharmacySensorsOnlySchema,
]);

export type ProductInformationFormType = z.infer<
  typeof productInformationFormSchema
>;
